export const initialState = {
  isFetched: false,
  id: null,
  imgDesktop: null,
  imgMobile: null,
  title: null,
  description: null,
  gender: null,
  products: [],
  url: null,
}

export const setCollection = (state, payload) => (
  { ...state, ...payload, isFetched: true }
)

export const setFetched = (state, payload) => (
  { ...state, isFetched: payload }
)
